import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Spin } from "antd";

function InfiniteScrollLoader() {
  return (
    <Box
      justifyContent="center"
      alignItems="center"
      d="flex"
      flex={1}
      my="16px"
    >
      <Flex gap="16px">
        <Spin />
        Carregando...
      </Flex>
    </Box>
  );
}

export default InfiniteScrollLoader;
